import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/techniques`;

const getAuthConfig = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/// GET
export const getAllTechniques = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/allTechniques`,
      getAuthConfig()
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des techniques:", error);
    throw error;
  }
};

// Techniques judo sans certaines familles
export const getTechniquesJudo = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/techniques-judo`,
      getAuthConfig()
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des techniques judo:", error);
    throw error;
  }
};

// Techniques judo sans self-défense
export const getJudoTechniquesWithoutSelfDefense = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/techniques-judo-without-self-defense`,
      getAuthConfig()
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des techniques judo sans self-defense:",
      error
    );
    throw error;
  }
};

// Techniques UV2
export const getTechniquesUV2 = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/techniques-uv2`,
      getAuthConfig()
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des techniques UV2:", error);
    throw error;
  }
};

/// POST
export const addTechnique = async (technique) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addTechnique`,
      technique,
      getAuthConfig()
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'une technique:", error);
    throw error;
  }
};

/// PUT
export const updateTechnique = async (id, technique) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateTechnique/${id}`,
      technique,
      getAuthConfig()
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour d'une technique:", error);
    throw error;
  }
};

/// DELETE
export const deleteTechnique = async (id) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteTechnique/${id}`,
      getAuthConfig()
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression d'une technique:", error);
    throw error;
  }
};